
let pendingContact = null;

export const setPendingContact = (contact) => {
  console.log("saving pending contact",contact)
  pendingContact = contact;
//  sessionStorage.setItem("pendingContact", JSON.stringify(contact)); // persistent
};

export const consumePendingContact = () => {
  // if (pendingContact) {
  //   const temp = pendingContact;
  //   pendingContact = null;
  //   return temp;
  // }

  // const stored = sessionStorage.getItem("pendingContact");
  // if (stored) {
  //   sessionStorage.removeItem("pendingContact");
  //   return JSON.parse(stored);
  // }

  // return null;

  const draft = pendingContact;
  console.log("consuming pending contact",draft);
  pendingContact = null;
  return draft;

};

export const peekContactDraft = () => pendingContact;

